import app from '@/common/public.js';
import { GetCustomerBaseInfoList, IsPrivilegeStaffs, LoginInit } from '@/api/common/common.js';
import store from '@/store/index.js';
import { AGENTPLATID } from '@/common/config/enterpriseAppConfig.js';
import { queryEnterpriseConfigurationInfo } from '@/api/platform/tripwise-m';

//初始化客户部门列表信息
export function getDepartmentList() {
  let settings = app.GetSettings();
  let memberId = (settings.MemberInfo || {}).MemberId;
  if (memberId) {
    let params = {
      CustomerIds: [(settings.MemberInfo || {}).MemberId],
    };
    app.Post(
      GetCustomerBaseInfoList,
      params,
      (res) => {
        if (app.GetResultState(res)) {
          if ((res.Data.CustomerBaseInfos || []).length > 0) {
            settings = app.GetSettings();
            settings.CustomerDepartmentList = (res.Data.CustomerBaseInfos || [])[0].DepartmentInfoList || [];
            app.SetSettings(settings);
          }
        }
      },
      null,
      true,
    );
  }
}

let isGetPrivilegeStaffsDone = false;
//初始化统一代订
export function getIsPrivilegeStaffs() {
  return new Promise((resolve, reject) => {
    if (isGetPrivilegeStaffsDone) {
      let settings = app.GetSettings();
      resolve(settings.isPrivilegeStaffs);
      app.Post(
        IsPrivilegeStaffs,
        {},
        (res) => {
          if (app.GetResultState(res)) {
            let settings = app.GetSettings();
            settings.isPrivilegeStaffs = res.Data.IsPrivilegeStaff;
            app.SetSettings(settings);
            store.commit('common/setIsPrivilegeStaff', settings.isPrivilegeStaffs);
            isGetPrivilegeStaffsDone = true;
          }
        },
        null,
        true,
      );
    } else {
      app.Post(
        IsPrivilegeStaffs,
        {},
        (res) => {
          if (app.GetResultState(res)) {
            let settings = app.GetSettings();
            settings.isPrivilegeStaffs = res.Data.IsPrivilegeStaff;
            app.SetSettings(settings);
            store.commit('common/setIsPrivilegeStaff', settings.isPrivilegeStaffs);
            resolve(settings.isPrivilegeStaffs);
            isGetPrivilegeStaffsDone = true;
          }
        },
        null,
        true,
      );
    }
  });
}

//初始化接口
export function loginInit() {
  app.Post(LoginInit, {}, (res) => {}, null, true);
}

export async function getEnterpriseConfiguration() {
  let param = {
    agentPlatId: '',
    clientType: 'h5',
    hostUrl: '',
  };

  const origin = window.location.origin;
  if (origin.includes('http://localhost') || origin.includes('192.168.0.34') || origin.includes('192.168.0.127')) {
    // param.hostUrl = 'https://uatmtrip.gdcts.com';
    param.hostUrl = app.webSiteUrl;
  } else {
    param.hostUrl = origin;
  }






  // https://clv.gdcts.com

  const enterpriseInfo = store.state.common.enterpriseInfo;
  if (enterpriseInfo && enterpriseInfo.agentAppName) {
    updateEnterpriseInfo(param); // 更新企业信息
    return enterpriseInfo;
  } else {
    // 缓存里没有，请求接口获取企业信息
    const data = await updateEnterpriseInfo(param);
    return data;
  }
}

function updateEnterpriseInfo(param) {
  return new Promise((resolve) => {
    app.Post(queryEnterpriseConfigurationInfo, param, (response) => {
      if (app.GetResultState(response)) {
        if (response.data && response.data.apiUrl) {
          let settings = app.GetSettings();
          let platId = '';

          platId = app.GetQueryString('platId') || '';

          settings.currentApi = response.data.apiUrl + '/'; // 存apiUrl
          if (platId) {
            settings.platId = platId;
          } else {
            settings.platId = response.data.platId;
          }
          app.plantId = platId;
          app.SetSettings(settings);
        }
        store.commit('common/updateEnterpriseInfo', response.data);
        resolve(response.data);
      } else {
        app.Toast(response.message);
      }
    });
  });
}
